import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import {
    deletedRestoreLanguages,
    deleteLanguages,
    setLanguages,
    setLanguagesRestoreData,
    updateLanguages,
} from "./languagesSlice";

import { IErrorResponse } from "../../../../types";
import { ILanguageCreate, IEditLanguage } from "../types";

const CreateLanguages = createAsyncThunk(
    "add/language",
    async ({ name, published, flag, slug, status, isDefault }: ILanguageCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/languages", {
                name,
                slug,
                flag,
                status,
                default: isDefault,
                published,
            });

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const GetLanguages = createAsyncThunk("get/languages", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("/languages");

        dispatch(setLanguages(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});
const EditLanguage = createAsyncThunk(
    "edit/language",
    async (language: IEditLanguage, { rejectWithValue, dispatch }) => {
        try {
            const { id, name, slug, flag, status, isDefault, published } = language;
            const response = await request.put(`/languages/${id}`, {
                name,
                slug,
                flag,
                status,
                default: isDefault,
                published,
            });
            dispatch(updateLanguages(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteLanguage = createAsyncThunk("delete/language", async (id: number, { rejectWithValue, dispatch }) => {
    try {
        const response = await request.delete(`/languages/${id}`);

        dispatch(deleteLanguages(id));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetDeleteLanguages = createAsyncThunk("get/delete/languages", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/languages/deleted-items`);

        dispatch(setLanguagesRestoreData(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteLanguage = createAsyncThunk(
    "delete/delete/languages",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/languages/restore/${id}`);

            dispatch(deletedRestoreLanguages(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export { GetLanguages, CreateLanguages, EditLanguage, DeleteLanguage, GetDeleteLanguages, RestoreDeleteLanguage };
